module.exports = __webpack_public_path__ + "static/img/stayInIcon.52544194.png";